import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    'server_error_show' : false,
    'axios_waiting' : false,
    'alert_message' : {
      'show' : false,
      'type' : '',
      'message' : ''
    },
    'router_loading_show' : true,
  },
  mutations: {

  },
  actions: {

  }
})
